import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const messages = {
  added: gql`
    subscription ChatMessagesAddedSubscription($slug: String!) {
      messageAdded(channelSlug: $slug) {
        message {
          ...ChatMessage
        }
      }
    }

    ${Fragments.chat.message}
  `,
  edited: gql`
    subscription ChatMessagesEditedSubscription($slug: String!) {
      messageEdited(channelSlug: $slug) {
        message {
          ...ChatMessage
        }
      }
    }

    ${Fragments.chat.message}
  `,
};

export const isTyping = gql`
  subscription ChatIsTypingSubscription($slug: String!) {
    isTyping(channelSlug: $slug) {
      channel {
        id
        slug
        isTyping {
          ...ShortUser
        }
      }
    }
  }

  ${Fragments.user.short}
`;

export const readMarkers = gql`
  subscription ChatReadMarkersSubscription($slug: String!) {
    readMarkerUpdated(channelSlug: $slug) {
      channel {
        id
        slug
        userReadMarkers {
          ...ChatUserReadMarker
        }
      }
    }
  }

  ${Fragments.chat.readMarker}
`;
